import React from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import About from './components/About'
import Services from './components/Services'
import FeaturedVehicles from './components/FeaturedVehicles'
import Advantages from './components/Advantages'
import Contact from './components/Contact'
import Footer from './components/Footer'
import Reviews from './components/Reviews'

function App() {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <Hero />
      <About />
      <Services />
      <FeaturedVehicles />
      <Advantages />
      <Reviews />
      <Contact />
      <Footer />
    </div>
  )
}

export default App
